import React from "react";
import styles from "./OnboardingStage.module.css";

const OnboardingConclusion = ({ title = "Conclusion", text = "" }) => {
  if (!text) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>{title}</h3>
      <div className={styles.summaryCard}>
        <h4 className={styles.summaryTitle}>What Does This Mean?</h4>
        <p className={styles.summaryText}>{text}</p>
      </div>
    </div>
  );
};

export default OnboardingConclusion;
